module.exports = __webpack_public_path__ + "static/pigly02-7e33cbb3d25c1116afd444211218cc3a.png";